import React from 'react';

const BicyclePopup = ({ bicycle, onClose }) => {
  if (!bicycle) return null;

  const formUrl = "https://forms.gle/5pAdtXedk41wTgQ27";

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>
        <h2 className="popup-title">{bicycle.title}</h2>
        <div className="popup-image">
          <img src={bicycle.imagePath} alt={bicycle.title} />
        </div>
        <div className="popup-details">
          {bicycle.sold ? (
            <p className="out-of-stock-popup">Out of Stock</p>
          ) : (
            <div className="price-section">
              <p><strong>Rental Price:</strong> ₹{bicycle.priceRental}/semester</p>
              <p><strong>Selling Price:</strong> ₹{bicycle.priceSelling}</p>
            </div>
          )}
        </div>

        {!bicycle.sold && (
          <div className="form-button-section">
            <a
              href={formUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="interest-button"
            >
              Interested? Click here!
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default BicyclePopup;
